module.exports = __webpack_public_path__ + "static/media/ON.2dea2a03.svg";